export const HOSTNAMES = {
  settleProduction: 'app.settle.co',
  escalonProduction: 'escalon.settle.co',
  settleDemo: 'demo-app.settle.co',
  escalonDemo: 'demo-escalon.settle.co',
}
export const PRODUCTION_HOSTNAMES = [HOSTNAMES.settleProduction, HOSTNAMES.escalonProduction]
export const DEMO_HOSTNAMES = [HOSTNAMES.settleDemo, HOSTNAMES.escalonDemo]

/** Reserved host (RFC 6761), only a `new URL()` base so URL helpers work without `window`. */
export const URL_PARSING_BASE = 'https://settle.invalid'
